'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const theme_Colors = require('../../../theme/Colors.cjs.js');
const theme_Shadows = require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');

const root = "_root_c1gxj_1";
const styles = {
	root: root
};

const Surface = ({ backgroundColor, shadow, borderColor, children }) => {
  return jsxRuntime.jsx("div", { className: styles.root, style: {
    "--_zds-surface-background": backgroundColor ? theme_Colors.Colors[backgroundColor] : "",
    "--_zds-surface-border": borderColor ? theme_Colors.Colors[borderColor] : "",
    "--_zds-surface-shadow": shadow ? theme_Shadows.Shadows[shadow] : ""
  }, "data-zds": true, "data-has-background": Boolean(backgroundColor), "data-has-border": Boolean(borderColor), "data-has-shadow": Boolean(shadow), children });
};

exports.Surface = Surface;
//# sourceMappingURL=Surface.cjs.js.map
